<div
  class="color-picker-overlay"
  [class.is-active]="_isColorPickerOpened"
></div>

<div
  class="tool-bar-container"
  cdkDrag
  cdkDragBoundary="viewer-root"
  (cdkDragStarted)="_onToolBarDragStarted()"
  (cdkDragMoved)="_onToolBarDragMoved($event)"
  (cdkDragEnded)="_onToolBarDragEnded($event)"
>
  <div class="tool-bar" (touchmove)="$event.preventDefault()">
    <!-- <button
      [class.is-on]="_selectedTool === _Tool.Selection"
      (pointerdown)="_onSelectTool(_Tool.Selection)"
      (touchmove)="$event.preventDefault()"
    >
      <svg
        [class.is-on]="_selectedTool === _Tool.Selection"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 2L7 2L7 4L4 4L4 7L2 7L2 2ZM17 2L22 2L22 7L20 7L20 4L17 4L17 2ZM2 17L2 22L7 22L7 20L4 20L4 17L2 17ZM20 17L20 20L17 20L17 22L22 22L22 17L20 17Z"
          fill="currentColor"
        />
      </svg>
      <span
        class="select-highlight"
        [class.is-on]="_selectedTool === _Tool.Selection"
      ></span>
    </button> -->
    <button
      [class.is-on]="_selectedTool === _Tool.Pen1"
      (pointerdown)="_onSelectTool(_Tool.Pen1)"
      (touchmove)="$event.preventDefault()"
    >
      <svg
        [class.is-on]="_selectedTool === _Tool.Pen1"
        width="22"
        height="22"
        viewBox="0 0 24 20"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.14258 19.8927L12.1926 19.8927C13.5259 19.8927 14.7676 19.2344 15.5092 18.126C16.2509 17.026 16.4009 15.626 15.9009 14.3927L13.2092 7.73438L7.05091 7.73438L2.14258 19.8927Z"
          [attr.fill]="
            this._penConfigs['pen1']!.colors[
              this._penConfigs['pen1']!.colorIndex
            ].hex
          "
          [attr.fill-opacity]="this._penConfigs['pen1']!.opacity"
        />
        <path
          d="M10.1359 0.11084L7.46094 6.73584L12.8109 6.73584L10.1359 0.11084Z"
          [attr.fill]="
            this._penConfigs['pen1']!.colors[
              this._penConfigs['pen1']!.colorIndex
            ].hex
          "
          [attr.fill-opacity]="this._penConfigs['pen1']!.opacity"
        />
      </svg>
      <span class="weight-value" [class.is-on]="_selectedTool === _Tool.Pen1">{{
        this._penConfigs['pen1']!.width
      }}</span>
    </button>
    <button
      [class.is-on]="_selectedTool === _Tool.Pen2"
      (pointerdown)="_onSelectTool(_Tool.Pen2)"
      (touchmove)="$event.preventDefault()"
    >
      <svg
        [class.is-on]="_selectedTool === _Tool.Pen2"
        width="22"
        height="22"
        viewBox="0 0 26 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.14258 19.8927L12.1926 19.8927C13.5259 19.8927 14.7676 19.2344 15.5092 18.126C16.2509 17.026 16.4009 15.626 15.9009 14.3927L13.2092 7.73438L7.05091 7.73438L2.14258 19.8927Z"
          fill="currentColor"
          [attr.fill]="
            this._penConfigs['pen2']!.colors[
              this._penConfigs['pen2']!.colorIndex
            ].hex
          "
          [attr.fill-opacity]="this._penConfigs['pen2']!.opacity"
        />
        <path
          d="M10.1359 0.11084L7.46094 6.73584L12.8109 6.73584L10.1359 0.11084Z"
          fill="currentColor"
          [attr.fill]="
            this._penConfigs['pen2']!.colors[
              this._penConfigs['pen2']!.colorIndex
            ].hex
          "
          [attr.fill-opacity]="this._penConfigs['pen2']!.opacity"
        />
      </svg>
      <span class="weight-value" [class.is-on]="_selectedTool === _Tool.Pen2">{{
        this._penConfigs['pen2']!.width
      }}</span>
    </button>
    <button
      [class.is-on]="_selectedTool === _Tool.Pen3"
      (pointerdown)="_onSelectTool(_Tool.Pen3)"
      (touchmove)="$event.preventDefault()"
    >
      <svg
        [class.is-on]="_selectedTool === _Tool.Pen3"
        width="22"
        height="22"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.14258 19.8927L12.1926 19.8927C13.5259 19.8927 14.7676 19.2344 15.5092 18.126C16.2509 17.026 16.4009 15.626 15.9009 14.3927L13.2092 7.73438L7.05091 7.73438L2.14258 19.8927Z"
          fill="currentColor"
          [attr.fill]="
            this._penConfigs['pen3']!.colors[
              this._penConfigs['pen3']!.colorIndex
            ].hex
          "
          [attr.fill-opacity]="this._penConfigs['pen3']!.opacity"
        />
        <path
          d="M10.1359 0.11084L7.46094 6.73584L12.8109 6.73584L10.1359 0.11084Z"
          fill="currentColor"
          [attr.fill]="
            this._penConfigs['pen3']!.colors[
              this._penConfigs['pen3']!.colorIndex
            ].hex
          "
          [attr.fill-opacity]="this._penConfigs['pen3']!.opacity"
        />
      </svg>
      <span class="weight-value" [class.is-on]="_selectedTool === _Tool.Pen3">{{
        this._penConfigs['pen3']!.width
      }}</span>
    </button>
    <button
      [class.is-on]="_selectedTool === _Tool.Pen4"
      (pointerdown)="_onSelectTool(_Tool.Pen4)"
      (touchmove)="$event.preventDefault()"
    >
      <svg
        [class.is-on]="_selectedTool === _Tool.Pen4"
        width="22"
        height="22"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.14258 19.8927L12.1926 19.8927C13.5259 19.8927 14.7676 19.2344 15.5092 18.126C16.2509 17.026 16.4009 15.626 15.9009 14.3927L13.2092 7.73438L7.05091 7.73438L2.14258 19.8927Z"
          fill="currentColor"
          [attr.fill]="
            this._penConfigs['pen4']!.colors[
              this._penConfigs['pen4']!.colorIndex
            ].hex
          "
          [attr.fill-opacity]="this._penConfigs['pen4']!.opacity"
        />
        <path
          d="M10.1359 0.11084L7.46094 6.73584L12.8109 6.73584L10.1359 0.11084Z"
          fill="currentColor"
          [attr.fill]="
            this._penConfigs['pen4']!.colors[
              this._penConfigs['pen4']!.colorIndex
            ].hex
          "
          [attr.fill-opacity]="this._penConfigs['pen4']!.opacity"
        />
      </svg>
      <span class="weight-value" [class.is-on]="_selectedTool === _Tool.Pen4">{{
        this._penConfigs['pen4']!.width
      }}</span>
    </button>
    <button
      [class.is-on]="_selectedTool === _Tool.Text"
      (pointerdown)="_onSelectTool(_Tool.Text)"
      (touchmove)="$event.preventDefault()"
    >
      <sui-icon class="text-icon" name="텍스트필기" type="solid"></sui-icon>
      <span
        class="select-highlight"
        [class.is-on]="_selectedTool === _Tool.Text"
      ></span>
    </button>
    <button
      [class.is-on]="_isRulerOn"
      (pointerdown)="_toggleRuler()"
      (touchmove)="$event.preventDefault()"
    >
      <sui-icon
        class="ruler-icon"
        name="자"
        type="solid"
        [class.is-on]="_isRulerOn"
      ></sui-icon>
      <span class="select-highlight" [class.is-on]="_isRulerOn"></span>
    </button>
    <button
      [class.is-on]="_selectedTool === _Tool.Eraser"
      (pointerdown)="_onSelectTool(_Tool.Eraser)"
      (touchmove)="$event.preventDefault()"
    >
      <sui-icon
        class="eraser-icon"
        name="지우개"
        [class.is-on]="_selectedTool === _Tool.Eraser"
        type="solid"
      ></sui-icon>
      <span
        class="select-highlight"
        [class.is-on]="_selectedTool === _Tool.Eraser"
      ></span>
    </button>

    <div class="divider"></div>
    <button
      [disabled]="!_canRedo"
      (pointerdown)="_onRedoButtonClick()"
      (touchmove)="$event.preventDefault()"
    >
      <sui-icon name="앞으로 가기"></sui-icon>
    </button>
    <button
      [disabled]="!_canUndo"
      (pointerdown)="_onUndoButtonClick()"
      (touchmove)="$event.preventDefault()"
    >
      <sui-icon name="뒤로가기"></sui-icon>
    </button>
    <div class="divider"></div>
    <button (pointerdown)="_onClearButtonClick()">
      <sui-icon name="휴지통" type="solid"></sui-icon>
    </button>
    <div class="divider"></div>
    <button (pointerdown)="_onChangePageButtonClick(1)">
      <sui-icon name="페이지 앞으로" type="solid"></sui-icon>
    </button>
    <button (pointerdown)="_onChangePageButtonClick(-1)">
      <sui-icon name="페이지 뒤로" type="solid"></sui-icon>
    </button>
    <div class="divider"></div>
    <button (pointerdown)="_onCloseButtonClick($event)">
      <sui-icon name="엑스"></sui-icon>
    </button>
    <button class="handle" cdkDragHandle>
      <sui-icon name="옮기기" type="solid"></sui-icon>
    </button>
  </div>
  <div
    class="pen-controls"
    [ngClass]="toolbarPosition"
    *ngIf="_selectedPenConfig"
  >
    <div class="palette">
      <div class="colors">
        <ng-container
          *ngFor="
            let color of _penConfigs[this._selectedTool!].colors;
            index as i
          "
        >
          <div
            class="color"
            [class.is-selected]="_selectedPenConfig.colorIndex === i"
            [style.color]="color.hex"
            [style.border-color]="color.hex + '33'"
            (click)="_onPenColorClick(i, color)"
            [cdkMenuTriggerFor]="
              _selectedPenConfig.colorIndex === i ? colorPickerMenu : null
            "
            [cdkMenuTriggerData]="{ index: i }"
            (cdkMenuClosed)="_colorPickerClosed(); _isColorPickerOpened = false"
            (cdkMenuOpened)="_isColorPickerOpened = true"
          >
            <div class="circle"></div>
            <sui-icon name="플러스"></sui-icon>
          </div>
          <br *ngIf="i === _colors.length / 2 - 1" />
        </ng-container>
      </div>
    </div>
    <div class="slider width">
      <viewer-pen-width-slider
        [(width)]="_selectedPenConfig.width"
        (widthChange)="_onPenConfigChanged()"
        [min]="0.5"
        [max]="20"
        [step]="0.5"
      ></viewer-pen-width-slider>
    </div>
    <div class="slider opacity">
      <viewer-pen-opacity-slider
        [(opacity)]="_selectedPenConfig.opacity"
        (opacityChange)="_onPenConfigChanged()"
      ></viewer-pen-opacity-slider>
    </div>
  </div>

  <!-- 선택된 텍스트 객체 설정 컨트롤 -->
  <div
    class="selected-text-controls"
    [ngClass]="toolbarPosition"
    *ngIf="_isTextObjectSelected && _selectedTextObjectConfig"
  >
    <div class="palette">
      <div class="colors">
        <ng-container
          *ngFor="let color of _selectedTextObjectConfig.colors; index as i"
        >
          <div
            class="color"
            [class.is-selected]="_selectedTextObjectConfig.colorIndex === i"
            [style.color]="color.hex"
            [style.border-color]="color.hex + '33'"
            (click)="_onSelectedTextColorClick(i, color)"
            [cdkMenuTriggerFor]="
              _selectedTextObjectConfig.colorIndex === i
                ? selectedTextColorPickerMenu
                : null
            "
            [cdkMenuTriggerData]="{ index: i }"
            (cdkMenuClosed)="_colorPickerClosed(); _isColorPickerOpened = false"
            (cdkMenuOpened)="_isColorPickerOpened = true"
          >
            <div class="circle"></div>
            <sui-icon name="플러스"></sui-icon>
          </div>
          <br *ngIf="i === _colors.length / 2 - 1" />
        </ng-container>
      </div>
    </div>

    <!-- 선택된 텍스트 폰트 패밀리 선택 -->
    <!-- <div class="font-family-selector">
      <div class="font-dropdown">
        <button
          class="font-dropdown-button"
          [class.open]="isFontDropdownOpen"
          (click)="toggleFontDropdown()"
        >
          <span class="font-name">{{
            _selectedTextObjectConfig.fontFamily
          }}</span>
          <div class="dropdown-arrow">
            <sui-icon name="펼침"></sui-icon>
          </div>
        </button>
        <div class="font-dropdown-menu" [class.show]="isFontDropdownOpen">
          <div
            class="font-option"
            *ngFor="let font of fontOptions"
            [class.selected]="
              _selectedTextObjectConfig.fontFamily === font.value
            "
            (click)="selectFont(font.value, 'selected')"
          >
            <span [style.font-family]="font.value">{{ font.label }}</span>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 선택된 텍스트 폰트 크기 슬라이더 -->
    <div class="slider font-size">
      <viewer-pen-width-slider
        [(width)]="_selectedTextObjectConfig.fontSize"
        (widthChange)="_onSelectedTextFontSizeChanged()"
        [min]="10"
        [max]="50"
        [step]="1"
      ></viewer-pen-width-slider>
    </div>
  </div>
</div>

<ng-template #colorPickerMenu let-index="index">
  <div class="color-picker" cdkMenu>
    <viewer-color-picker
      (click)="$event.stopPropagation()"
      [initialColor]="_penConfigs[this._selectedTool!].colors[index].hex"
      (colorChange)="_colorChanged(index, $event)"
    ></viewer-color-picker>
  </div>
</ng-template>

<!-- 선택된 텍스트용 컬러피커 템플릿 -->
<ng-template #selectedTextColorPickerMenu let-index="index">
  <div class="color-picker" cdkMenu>
    <viewer-color-picker
      (click)="$event.stopPropagation()"
      [initialColor]="_selectedTextObjectConfig!.colors[index].hex"
      (colorChange)="_onSelectedTextColorChanged(index, $event)"
    ></viewer-color-picker>
  </div>
</ng-template>
